import React from 'react'

function Test() {
  return (
    <iframe src="http://localhost:3000/payment"></iframe>
  )
}

export default Test